<template>
  <img alt="Vue logo" src="./assets/logo.png" class="ll" :class="{l:result.length>0,l2:result.length===0}">
  <div style="display: flex;justify-content: center;flex-direction: column;align-items: center">
    <div class="se">
      <input v-model="kw" autofocus placeholder="使用举例：输入你需要的工具，然后按回车键" type="text" class="s" :class="{'c':result.length>0}" maxlength="128">
<!--      <div @click="handleInput2(kw)">搜索</div>-->
    </div>
    <div v-if="result.length===0" style="margin-top: 20px; width: 500px;max-width: 80%;">
      <div v-for="(word,idx) in words" class="ws" :key="idx" @click="kw=word">{{ word }}</div>
    </div>
  </div>
  <div class="m">
    <div v-for="(item,idx) in result" :key="item.id" class="item" :id="'item'+idx" :class="{ia:current===idx}" @click="click(item)">
      <img :src="item.icon" style="width:50px;height: 50px;margin-top: 5px;" alt="">
      <div style="width: 100%;">
        <div class="t"><span>{{item.name}}</span><div class="dot" :class="{act:item.is_ban===1}"></div></div>
        <div class="in">{{item.tool}} <span v-if="debug">{{item.score}}</span></div>
        <div class="tags"><span v-if="item.is_register===0">无需注册</span><span v-if="item.is_register===1">需要注册</span><span v-if="item.is_pay===1">付费</span></div>
      </div>
    </div>
  </div>
  <div></div>
  <div class="mst" @click.stop="showMenu=true" v-if="!showMenu"></div>
  <div class="menucont" :class="{menucoac:showMenu,menuco:!showMenu}">
    <div style="display: flex;justify-content: right;padding: 5px 5px;">
      <div class="menu" @click.stop="showMenu=!showMenu"><svg t="1751943838702" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4668" width="200" height="200"><path d="M905.2 144.9h-785c-31.3 0-56.7 25.6-56.7 57.3v7.7c0 31.6 25.4 36.4 56.7 36.4h785c31.3 0 56.7-4.7 56.7-36.4v-7.7c0-31.7-25.4-57.3-56.7-57.3zM800.7 459.8H120.2c-31.3 0-56.7 25.6-56.7 57.3v-13.2c0 31.6 25.4 57.3 56.7 57.3h680.5c31.3 0 56.7-25.6 56.7-57.3v13.2c0-31.6-25.4-57.3-56.7-57.3z m-104.4 315h-576c-31.3 0-56.7 25.6-56.7 57.3v7.7c0 31.6 25.4 36.4 56.7 36.4h576c31.3 0 56.7-4.7 56.7-36.4V832c0-31.6-25.4-57.2-56.7-57.2z" p-id="4669" fill="#ed7537"></path></svg></div>
    </div>
    <div :class="{hid:showMenu}">
      <div class="option">
        <span>显示需要翻墙的结果</span>
        <div class="switch" :class="{switch_yes:!config.showAll,switch_no:config.showAll}" @click="config.showAll=!config.showAll"><div></div></div>
      </div>
      <div class="option">
        <span>Enter打开网址</span>
        <div class="switch" :class="{switch_yes:!config.enter,switch_no:config.enter}" @click="config.enter=!config.enter"><div></div></div>
      </div>
      <div class="option" style="flex-direction: column;align-items: start;">
        <span>快捷键</span>
        <div class="kkk">
          <div>向上选择</div>
          <div class="kk">
            <span>回到顶部</span>
            <svg t="1751954315710" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9551" width="200" height="200"><path d="M512 716.8a25.6 25.6 0 0 1 25.1904 20.992l0.4096 4.608v194.2016l84.2752-84.3264a25.6 25.6 0 0 1 32.6656-2.9184l3.584 2.9184a25.6 25.6 0 0 1 2.9184 32.6656l-2.9184 3.584-128 128a25.6 25.6 0 0 1-32.6656 2.9184l-3.584-2.9184-128-128a25.6 25.6 0 0 1 32.6656-39.168l3.584 2.9184L486.4 936.6016V742.4a25.6 25.6 0 0 1 25.6-25.6zM171.7248 365.8752a25.6 25.6 0 0 1 2.9184 32.6656l-2.9184 3.584L87.3472 486.4H281.6a25.6 25.6 0 0 1 4.608 50.7904l-4.608 0.4096H87.3472l84.3776 84.2752a25.6 25.6 0 0 1 2.9184 32.6656l-2.9184 3.584a25.6 25.6 0 0 1-32.6656 2.9184l-3.584-2.9184-128-128a25.6 25.6 0 0 1-2.9184-32.6656l2.9184-3.584 128-128a25.6 25.6 0 0 1 36.2496 0z m713.216-2.9184l3.584 2.9184 128 128a25.6 25.6 0 0 1 2.9184 32.6656l-2.9184 3.584-128 128a25.6 25.6 0 0 1-39.168-32.6656l2.9184-3.584 84.3264-84.2752H742.4a25.6 25.6 0 0 1-4.608-50.7904l4.608-0.4096h194.2016l-84.3264-84.2752a25.6 25.6 0 0 1-2.9184-32.6656l2.9184-3.584a25.6 25.6 0 0 1 32.6656-2.9184zM512 460.8a51.2 51.2 0 1 1 0 102.4 51.2 51.2 0 0 1 0-102.4z m14.5408-456.2432l3.584 2.9184 128 128a25.6 25.6 0 0 1-32.6656 39.168l-3.584-2.9184L537.6 87.3472V281.6a25.6 25.6 0 0 1-50.7904 4.608L486.4 281.6V87.3472L402.1248 171.7248a25.6 25.6 0 0 1-32.6656 2.9184l-3.584-2.9184a25.6 25.6 0 0 1-2.9184-32.6656l2.9184-3.584 128-128a25.6 25.6 0 0 1 32.6656-2.9184z" fill="#f34436" fill-opacity="0.8" p-id="9552"></path></svg>
            <span>打开链接</span>
          </div>
          <div>向下选择</div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="result.length===0" style="position:fixed;right: 10px;top:0;font-size: 14px;color: #333;">当前共收录 {{sites.length}} 个工具</div>
</template>

<script>
import init, { cut,cut_for_search,cut_all } from 'jieba-wasm';
// import Fringerprint from './libs/browser_fingerprint'
import {Spinner} from 'spin.js'
import 'spin.js/spin.css'
const day=new Date().toISOString().slice(0, 10).replace(/-/g, "")
export default {
  name: 'App',
  components: {
  },
  data(){
    return {
      words:["临时邮箱","坐标拾取","在线抠图","在线PS","录屏","白板","二维码","JSON格式化","美国身份生成","PDF文字提取","在线OCR","条码生成","IP 地址查询","在线白噪音"
      ,"DNS 检测","图片EXIF信息","房贷计算器","BASE64编码解码","时间戳","md5","进制转换","JWT解密","教育邮箱","域名备案查询","在线调音","WebSocket 在线测试"
      ,"今天吃什么","正则表达式","亲戚关系计算","添加水印","生成九宫格","图片变清晰","图片文字替换","图片去水印","背景替换","图片风格转换","图片提取线稿",
      "AI扩图","markdown编辑器","万年历","whois查询"],
      config:{
        showAll:false,
        enter:true
      },
      showMenu:true,
      result:[],
      kw:'',
      sites:[],
      allKeywords:{},
      current:0,
      totalHeight:0,
      pageHeight:0,
      online:-1,
      debug:false
    }
  },
  watch:{
    showMenu(newVal){
      if(newVal){
        this.focus()
      }
    },
    'config.showAll'(newVal){
      localStorage.setItem("config",JSON.stringify(this.config))
      if(this.result){
        this.handleInput2(this.kw)
      }
    },
    'config.enter'(newVal){
      localStorage.setItem('config'+day,JSON.stringify(this.config))
    },
    online(newVal){
      this.config.showAll=newVal===1
      if(localStorage.getItem("config")){
        const config=JSON.parse(localStorage.getItem("config"));
        this.config.showAll=config.showAll
      }else{
        localStorage.setItem("config",JSON.stringify(this.config))
      }

    },
    kw(newVal){
      this.handleInput2(newVal)
    },
    current(newVal){
      // let dom=document.getElementById('item'+newVal);
      // if(!dom)return;
      // const rect = dom.getBoundingClientRect();
      //
      // let top=rect.top+window.scrollY-window.innerHeight/2
      //
      // window.scrollTo({
      //   top:top,
      //   left:0,
      //   behavior:'smooth'})
    }
  },
  async mounted() {
    var spinner = new Spinner().spin();
    document.body.appendChild(spinner.el);

    await init()

    spinner.stop()

    if(location.href.toLowerCase().indexOf('localhost')>=0){
      this.debug=true
    }
    document.addEventListener("visibilitychange", ()=>{
      if(!document.hidden){
        // this.focus()
      }
    });
    try{
      setTimeout(()=>{
        if(this.online<0){
          this.online=0
        }
      },3000)
      var image = new Image();
      image.onload = ()=>{
        this.online=1;
      };
      image.onerror = ()=>{
        this.online=0;
      };
      image.src = "http://youtube.com/favicon.ico";
    }catch (e){}

    this.pageHeight=document.body.scrollHeight
    let midScrollTop=-1
    window.addEventListener('wheel', (event) =>{
      if(this.result.length===0)return;
      //
      // if(event.deltaY>0){
      //   //向下
      //   if(this.current<this.result.length-1){
      //     this.current+=1
      //   }
      // }else if(event.deltaY<0){
      //   //向上
      //   if(this.current>=1){
      //     this.current-=1
      //   }
      // }
      // midScrollTop=window.scrollY
    });
    window.addEventListener('scroll', ()=> {
      if(this.result.length===0)return;
    }, false);

    document.addEventListener('keydown', (e) =>{
      switch (e.keyCode) {
        case 13:
          this.search(this.kw)
          break;
        case 37:
          e.preventDefault()
          console.log("左键按下");
          midScrollTop=-1
          window.scrollTo({
            top:0,
            left:0,
            behavior:'smooth'})
          break;
        case 38:
          e.preventDefault()
          console.log("上键按下");
          if(this.current===0){
            return
          }
          this.current-=1
          break;
        case 39:
          e.preventDefault()
          console.log("右键按下");
          this.search(this.kw)
          break;
        case 40:
          e.preventDefault()
          console.log("下键按下");
          if(this.current>=this.result.length-1){
            return;
          }
          this.current+=1
          break;
      }
    });

//     const re=await Fringerprint.createdFingerprint();
//     console.log(re)
// // 监听指纹变化
//     window.addEventListener('fingerprintchange', event => {
//       console.log('指纹已更新:', event.detail.newFingerprint);
//     });

    if(localStorage.getItem('config')){
      this.config=JSON.parse(localStorage.getItem("config"))
      if(!('enter' in this.config)){
        this.config.enter=true
      }
    }

    const response = await fetch('./files/sites.json');
    // const response=await fetch('https://1twiki.xumingxun.com/api/index')
    let resp = await response.json();
    let items=resp.sites
    let version=resp.version

    let allKeywords= {}

    let calcKeyword=false

    let localVersion=localStorage.getItem("version");

    let json=null;
    if(localVersion==version){
      json=localStorage.getItem('pp');
    }

    if(!json){
      calcKeyword=true
    }

    let hosts={}

    let totalKeyword=0;
    for(let item of items){
      if(!item.icon){
        item.icon='/static/icon/blank.png'
      }
      let words=this.cut_for_search(item.tool)
      words=words.filter(item=>item.trim()!=='')
      words=words.map(item=>item.toLowerCase())

      let words2=this.cut(item.name)
      words2=words2.filter(item=>item.trim()!=='')
      words2=words2.map(item=>item.toLowerCase())

      if(calcKeyword){
        for(let w of words){
          if(allKeywords[w]){
            allKeywords[w]+=1
          }else{
            allKeywords[w]=1;
          }
          totalKeyword+=1
        }
        for(let w of words2){
          if(allKeywords[w]){
            allKeywords[w]+=1
          }else{
            allKeywords[w]=1;
          }
          totalKeyword+=1
        }
      }

      words=Array.from(new Set(words))
      item.keywords=words

      words2=Array.from(new Set(words2))
      item.names=words2

      item.rate= item.rate + 0.05 * this.squareRootInverse(item.keywords.length+item.names.length) / 20

      const host=this.getUrlHost(item.url)
      item.host=host
      if(hosts[host]){
        hosts[host]+=1
      }else{
        hosts[host]=1
      }
    }
    let hostScore={}
    for(let host in hosts){
      // console.log(host+"/"+Math.log(hosts[host]/items.length))
      if(hosts[host]>10){
        hostScore[host]=0.9
      }else{
        hostScore[host]=1.0
      }
    }
    for(let item of items){
      if(hostScore[item.host]){
        item.rate *= hostScore[item.host]
      }
    }

    console.log(hosts)
    if(calcKeyword){
      for(let k in allKeywords){
        allKeywords[k]=Math.log(totalKeyword/(allKeywords[k]+1))*0.1
      }
      this.allKeywords=allKeywords
      localStorage.setItem("pp",JSON.stringify(this.allKeywords))
      localStorage.setItem("version",version)
    }else{
      console.log("-----------------")
      this.allKeywords=JSON.parse(json)
    }


    // 100
    // App.vue:144 0.3256946530424913
    // App.vue:145 0.029608708650542565
    // App.vue:146 0.006832779108393644
    this.sites=items
    // setTimeout(()=>{
    //   this.kw="中文"
    // })
  },
  methods:{
    squareRootInverse(percentage, maxScore = 20){
      // 确保百分比在有效范围内
      const p = Math.min(Math.max(percentage, 0), 100);
      // 平方根变换
      return maxScore * (1 - Math.sqrt(p / 100))
    },
    getUrlHost(url) {
      try {
        const urlObj = new URL(url);
        return urlObj.host;
      } catch (error) {
        console.error('无效的URL:', error);
        return null;
      }
    },
    focus(){
      document.getElementsByClassName('s')[0].focus()
    },
    click(i){

      console.log(i)
      let idx=this.result.findIndex(item=>item.id===i.id)
      this.current=idx
      this.search('go');
    },
    custom_search(kw){
      let searchWords=this.cut(kw)

      let arr=[]
      for(let b of this.sites){
        // let words=this.cut(b.tool)
        let flag;
        if(b.name.indexOf('草料')>=0 || b.url.indexOf('https://tool.lu/qrcode/')>=0){
          console.error(b)
          console.error(this.config)
          flag=b.name
        }

        if(!this.config.showAll&&b.is_ban===1){
          continue
        }


        let words=b.keywords

        let score=0
        for(let word of words){
          for(let sw of searchWords){
            sw=sw.toLowerCase();
            if(!this.allKeywords[sw]){
              continue;
            }
            if(word===sw){
              score+= 1 * this.allKeywords[sw]
              if(flag){
                console.log(flag+":"+word+","+sw+","+score+",1")
              }
            }else if(sw.indexOf(word)>=0){
              score+=0.5 * this.allKeywords[sw]
              if(flag){
                console.log(flag+":"+word+","+sw+","+score+",0.5")
              }
            }
          }
        }
        words=b.names
        for(let word of words){
          for(let sw of searchWords){
            sw=sw.toLowerCase();
            if(!this.allKeywords[sw]){
              continue;
            }
            if(word===sw){
              score+= 0.25 * this.allKeywords[sw]
              if(flag){
                console.log(flag+":"+word+","+sw+","+score+",1")
              }
            }else if(sw.indexOf(word)>=0){
              score+=0.125 * this.allKeywords[sw]
              if(flag){
                console.log(flag+":"+word+","+sw+","+score+",0.5")
              }
            }
          }
        }

        if(score===0){
          continue
        }

        if(flag){
          console.log(flag+":"+b.rate+","+score)
        }
        b.score=score*b.rate
        if(flag){
          console.log(flag+":"+b.score)
        }
        arr.push(b)
      }

      arr.sort((a,b)=>-a.score+b.score)
      this.current=0
      if(arr.length>20){
        arr=arr.splice(0,20)
      }
      this.result=arr
      this.$forceUpdate()
    },
    cut(text){
      // 去除标点符号和空格
      const cleaned = (""+text).replace(/[^\u4e00-\u9fa5a-zA-Z0-9\s]/g, ' ').trim();
      // 用jieba分词
      return cut(cleaned, true); // true表示精确模式
    },
    cut_for_search(text){
      // 去除标点符号和空格
      const cleaned = (""+text).replace(/[^\u4e00-\u9fa5a-zA-Z0-9\s]/g, ' ').trim();
      // 用jieba分词
      return cut_for_search(cleaned, true); // true表示精确模式
    },
    async search(e){
      if('go'!==e){
        if(!('enter' in this.config)){
          this.config.enter=true
        }
        if(!this.config.enter){
          return
        }
      }
      if(this.result.length>this.current && this.current>=0){
        setTimeout(()=>{
          window.open(this.result[this.current].url, '_blank');
        },300)
      }
    },
    async handleInput(e){
    },
    async handleInput2(e){
      const userInput =e;//this.kw// e.target.value
      console.log(userInput)
      if(!userInput||userInput.length<2){
        this.current=-1
        this.result=[]
        this.$forceUpdate()
        return;
      }
      this.custom_search(userInput)
    }
  }
}
</script>

<style>
.ws{
  font-size: 14px;
  color: #444;
  margin-right: 20px;
  cursor: pointer;
  display: inline-block;
  margin-bottom: 12px;
}
.tags{
  margin-top: 5px;
}
.tags span{
  margin-right: 12px;
  font-size: 12px;
  background: #51b5e4;
  padding: 1px 4px;
  border-radius: 3px;
  color: white;
}
.kkk{
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  font-size: 12px;
  width: 100%;
}
.kk{
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.kk span{
  font-weight: normal!important;
  font-size: 12px!important;
}
.kk svg{
  width: 90px;
  height: 90px;
}
.se{
  width: 500px;max-width: 80%;
  position: relative;
  display: flex;
  align-items: center;
}
.se div{
  position: absolute;
  right: 7px;
  width: 90px;
  height: 36px;
  background: #f34436;
  border-radius: 18px;
  color: white;
  top:4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hid{
  opacity: 0;
}
.option{
  display: flex;justify-content: space-between;;align-items: center;
  padding: 10px 14px;
}
.option span{
  font-size: 14px;
  color:#444;
  font-weight: bold;
}
.switch_yes{
  justify-content: left;
  background: #fcebeb;
}
.switch_no{
  justify-content: right;background: #f34436;
  opacity: 0.8;
}
.switch_no div{
  background: #fcebeb!important;
}
.switch{
  width: 50px;height: 24px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.switch div{
  width:18px;height: 18px;border-radius: 50%;background: #f34436;
  margin: 4px;
}
.mst{
  position: fixed;;
  width: 100%;
  height: 100%;
  left:0;right: 0;top:0;bottom: 0;
  z-index: 5;
}

.menucont{
  z-index: 10;
  width: 280px;position: fixed;top:0;bottom:0;
  background: #f6f6f6;border-right: rgba(0,0,0,0.2);

}
.menuco{
  left:0px;
  transition: left 0.5s ease;
}
.menucoac{
  left:-247px;
  transition: left 0.5s ease;
  background: rgba(0,0,0,0);
}
.menu{
  width: 23px;height: 23px;
  display: inline-block;
  cursor: pointer;
}
.menu svg{
  width: 100%;
  height: 100%;
}
.m{
  display: flex;
  align-items: center;
  flex-direction: column;
}
.item{
  display: flex;
  margin-top: 30px;
  padding: 12px;
  border-radius: 8px;
  width:700px;
  cursor: pointer;
  border:1px solid rgba(0,0,0,0);
  max-width: 90%;
}
.item:hover{
  border: 1px solid rgba(238,118,55,0.2);
}
.ia{
  /*border: 1px solid rgba(238,118,55,0.2);*/
  background: rgba(238,118,55,0.1);
}
.item div{
  text-align: left;
  padding-left: 12px;
}
.item div .t{
  font-size: 18px;
  color: #333;
  max-width: 100%;
  justify-content: space-between;
  align-items: center;
  display: flex;
}
.item div .t span{
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.item div .t .dot{
  width: 8px;
  min-width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 50%;
  background: #42b983;
  padding-left: 0;
  opacity: 0.8;
}
.item div .t .dot.act{
  background:orangered;
}
.item div .in{
  color: #666;
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-top:3px;
}
.item img{
  width: 64px;
  height: 40px;
}
.s{
  appearance: none;height:40px;padding-left:20px;font-size:18px;width:100%;
  border:1px solid #999;border-radius: 20px;
  color: #444;
}
.s:focus{
  outline: none;
  border:1px solid rgba(238,118,55,1);
  caret-color: rgba(238,118,55,1);
  caret-shape: block;
}
.c{
  /*margin-top: 20px;*/
}

.l{
  width: 200px;
  margin-top: 40px;
  transition: all 0.5s ease;
  margin-bottom: 30px;
}
.l2{
  width: 280px;
  margin-top: 120px;
  transition: all 0.5s ease;
  margin-bottom: 70px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
